import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, Select as MUISelect } from '@material-ui/core';
import { ISelectProps } from '../../constants/commonTypes';

const Select = (props: ISelectProps) => {
  const { onChange, value, children, ...rest } = props;

  return (
    <FormControl>
      <MUISelect
        value={value}
        onChange={onChange}
        inputProps={{ 'aria-label': 'Without label' }}
        displayEmpty
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          getContentAnchorEl: null
        }}
        {...rest}
      >
        {children}
      </MUISelect>
    </FormControl>
  )
}

Select.defaultProps = {
  onChange: () => { },
  value: "",
  children: null,
  className: "",
  disabled: false,
}

Select.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
}

export default Select;
